import { ArcadeIconNames } from './ArcadeIcon'
import { IconNames as BronteIconNames } from './Icon'

export type OptionalRecord<K extends string | number | symbol, T> = {
  [P in K]?: T
}

export const BRONTE_TO_ARCADE_ICONS_MAPPING_GENERATED: OptionalRecord<BronteIconNames, ArcadeIconNames> = {
  ShoppingCart: 'ShoppingCart',
  Menu: 'MenuAfterpay',
  NoCreditCheck: 'NoCreditCheck',
  Add: 'Add',
  ArrowDown: 'TickerDown',
  ArrowUp: 'TickerUp',
  Bank: 'BankAccount',
  Calendar: 'Date',
  Camera: 'CameraFill',
  Car: 'CategoryAuto',
  Card: 'CardBasic',
  CardUpdate: 'CardInactive',
  CaretDown: 'Expand',
  CaretRight: 'Push',
  CaretUp: 'Collapse',
  Chat: 'CommChat',
  Chatting: 'CommChat',
  Cheque: 'DepositCheck',
  Close: 'Close',
  CloseCircle: 'Clear',
  CurrencyExchange: 'SwapCurrency',
  Dollar: 'CurrencyUsd',
  Download: 'Download',
  Edit: 'Edit',
  Email: 'CommEmail',
  Exit: 'LogOut',
  Filter: 'Control',
  Gift: 'Giftcard',
  Globe: 'International',
  Heart: 'Like',
  History: 'Time',
  Home: 'CategoryRent',
  Info: 'InformationOutline',
  Lightning: 'BitcoinLightning',
  Link: 'Hyperlink',
  Location: 'Location',
  Lock: 'LockLocked',
  Message: 'CommSmsFill',
  MobileBanking: 'DeviceMobile',
  MoneyTransfer: 'TransferWire',
  More: 'More',
  Notification: 'Notifications',
  PasswordHide: 'SensitiveHidden',
  PasswordShow: 'SensitiveVisible',
  Phone: 'CommPhoneFill',
  Pie: 'Data',
  Piggy: 'Savings',
  Profile: 'Avatar',
  Refresh: 'Refresh',
  Refund: 'Refunded',
  Search: 'Search',
  Send: 'Send',
  Settings: 'Control',
  Share: 'Share',
  Shop: 'CategoryShopping',
  Support: 'CardSupport',
  Trash: 'Clear',
  Warning: 'AlertFill',
  // Sale: 'DiscountTagFill',
  // Discount: 'DiscountPercentage',
  // Work: 'Business',
  Star: 'FavoriteFill',
  // 'Star-Hollow': 'Favorite',
  Copy: 'Copy',
  // Location2: 'LocationFill',
  Map: 'LocationDuo',
  Grid: 'PayInFour',
  External: 'LinkOut',
  Box: 'CategoryMoving',
  // Shipping: 'Delivery',
  Bulb: 'Idea',
  Verified: 'AccountVerified',
  Discount2: 'DiscountTag',
  Merchant: 'CategoryShopping',
  Write: 'Edit',
  Attachment: 'Attach',
  ArrowLeft: 'TickerLeft', // manually mapped,
  CaretLeft: 'BackCentered', // manually mapped,
  ArrowRight: 'TickerRight', // manually mapped,
  Printer: 'Printer',
  Check: 'Check',
  Loan: 'Borrow', // manually mapped,
  Barcode: 'DepositBarcode', // manually mapped,
  MoneyTime: 'PayLater', // manually mapped,
  Order: 'Document', // manually mapped,
  Afterpay: 'LogoAfterpay', // manually mapped,
  NewByronPhoneGeneral: 'DeviceMobile', // manually mapped
} as const
